import {EntityType} from '../../features/Form/consts/EntityTypes';
//Action Icons
import {ReactComponent as iconWizard} from '../../images/Icon-actions-Wizard.svg';
import {ReactComponent as IconTypeD} from '../../images/Icon-actions-type-D.svg';
import {ReactComponent as IconTypeP1svg} from '../../images/Icon-actions-type-P-1.svg';
import {ReactComponent as IconPieLine} from '../../images/Icon-actions-Pie-Line-Graph.svg';
import {ReactComponent as IconTypeP2} from '../../images/Icon-actions-type-P-2.svg';
import {ReactComponent as IconTypeR} from '../../images/Icon-actions-type-R.svg';
import {ReactComponent as IconTypeF} from '../../images/Icon-actions-type-F.svg';

import styles from './styles.module.scss';

type ActionItem = {
    img: string;
    className: string;
    hoverClass: string;
    active: string;
};

export const getEntityIcon = (type: EntityType): ActionItem => {
    const icon = ActionIconData[type];
    return icon || defaultEntIcon;
};

const defaultEntIcon = {
    img: IconTypeP1svg,
    className: styles.greenColor,
    hoverClass: styles.greenHover,
    active: styles.greenActive
};

const ActionIconData = {
    [EntityType.FORM]: {
        img: IconTypeF,
        className: styles.primaryBlueColor,
        hoverClass: styles.primaryBlueHover,
        active: styles.primaryBlueActive
    },
    [EntityType.PROCEDURE]: {
        img: IconTypeP1svg,
        className: styles.greenColor,
        hoverClass: styles.greenHover,
        active: styles.greenActive
    },
    [EntityType.BIREPORT]: {
        img: IconTypeP2,
        className: styles.orangeColor,
        hoverClass: styles.orangeHover,
        active: styles.orangeActive
    },
    [EntityType.DASHBOARD]: {
        img: IconPieLine,
        className: styles.violetColor,
        hoverClass: styles.violetHover,
        active: styles.violetActive
    },
    [EntityType.REPORT]: {
        img: IconTypeR,
        className: styles.redColor,
        hoverClass: styles.redHover,
        active: styles.redActive
    },
    [EntityType.DOCUMENT]: {
        img: IconTypeD,
        className: styles.lightBlueColor,
        hoverClass: styles.lightBlueHover,
        active: styles.lightBlueActive
    },
    [EntityType.WIZARD]: {
        img: iconWizard,
        className: styles.aquaColor,
        hoverClass: styles.aquaHover,
        active: styles.aquaActive
    }
};
